import React from 'react'

export const Header = () => {
  return (
    <h2>
      Track Expenses by your-munim
    </h2>
  )
}